import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Button from 'builder/components/Button'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${Colors.Neutral5};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1551;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
`
export const WebcamContainer = styled.div`
  position: fixed;
  right: 20px;
  z-index: 1555;
  display: flex;
  overflow: hidden;
  justify-content: flex-end;
`

export const TopContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  ${Media.Tablet`
    grid-template-columns: 1fr 1fr;
  `}
`

export const Title = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
export const MiddleContainer = styled.div`
  height: 100%;
  display: flex;
  overflow: auto;
  justify-content: center;
  align-items: center;
`
export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`
export const Text = styled.div`
  ${Typography.L};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
  text-align: center;
  margin-bottom: 20px;
`

export const Note = styled.div<{ $display: string }>`
  padding-bottom: 16px;
  text-align: center;
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};

  display: ${({ $display }) => $display};
`

export const StartInterviewButton = styled(Button)`
  border-radius: ${Spacing['3XL']};
`

export const BottomCenterContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  right: 0;
  justify-content: center;

  ${Media.IphoneSE`
    position: unset;
  `}
`
